import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    signal,
    ViewChild,
    HostListener,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationService } from 'app/services/application.service';
import { Router, RouterModule } from '@angular/router';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import {
    MatExpansionModule,
    MatExpansionPanel,
} from '@angular/material/expansion';
import { InputSelectGeneralComponent } from 'app/components/input-select-general/input-select-general.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrService } from 'ngx-toastr';

type EligibilityReqType = {
    caseId: string;
    selection: [{ prodCode: string; selectedBranch?: string }];
};

@Component({
    selector: 'eligible',
    templateUrl: './eligible.component.html',
    styleUrls: ['./eligible.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        FooterComponent,
        HeaderComponent,
        RouterModule,
        MatExpansionModule,
        InputSelectGeneralComponent,
        MatRadioModule,
        MatDividerModule,
        ApplicationStepperComponent,
        MatCardModule,
        SlickCarouselModule,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class EligibleComponent implements OnInit {
    branches;
    selectedBranchIndex = null;
    panelOpenState = false;
    eligibilityDetails: any = {};
    caseId: any = '';
    prodCode: any;
    productsData: any;
    isAuthenticated: boolean = false;
    closeTostr: string;
    disableSubmitBtn: boolean = true;
    isToggleOpen = true;
    searchInput = '';
    initialBranchesList;
    productName: string;
    fromResume: any;
    selectedBranchName: string;
    stateOptions: [] = [];
    isStateDropdownOpen: boolean = false;
    selectedState: string = '';
    branchSuggestion: [] = [];
    prodvalidation: any;
    isDGP: boolean = false;

    value = 65;
    panelOpenStates = signal(true);
    currentSlide: number = 0;
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];

    constructor(
        private router: Router,
        private translate: TranslateService,
        private applicationService: ApplicationService,
        private toastr: ToastrService,
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }
        this.caseId =
            this.router.getCurrentNavigation().extras.state?.eligibilityDetailsData?.caseId;
        this.applicationService.checkCaseIdForRedirection(this.caseId);
        this.prodCode =
            this.router.getCurrentNavigation().extras.state?.eligibilityDetailsData?.prodCode;
        this.fromResume =
            this.router.getCurrentNavigation().extras.state?.fromResume;
        let eligibilityDetailsData =
            this.router.getCurrentNavigation().extras.state
                ?.eligibilityResponse;

        this.eligibilityDetails = eligibilityDetailsData[0];
        this.branches = this.eligibilityDetails.prodSelectionList.branchListing;

        this.productName =
            this.router.getCurrentNavigation().extras.state?.productName;
        if (this.fromResume && !this.productName) {
            this.productName =
                this.eligibilityDetails.prodSelectionList.prodNameList[0].productName;
        }

        if (
            this.eligibilityDetails?.prodSelectionList?.prodNameList?.length > 0
        ) {
            this.prodvalidation = JSON.parse(
                this.eligibilityDetails?.prodSelectionList?.prodNameList[0]
                    ?.productValidation
            );
            if(this.eligibilityDetails?.prodSelectionList?.prodNameList[0]?.productType === "DGP"){
                this.isDGP = true;
            }
        }

        this.initialBranchesList =
            this.eligibilityDetails.prodSelectionList.branchListing;
        if (
            this.eligibilityDetails.prodSelectionList.branchActive == 'N' ||
            !(
                this.eligibilityDetails?.prodSelectionList?.branchListing
                    ?.length > 0
            )
        ) {
            this.disableSubmitBtn = false;
        }
    }

    @HostListener('document:click', ['$event'])
    closeDropdown(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const dropdown = document.getElementById('stateDropdown');
        const branchSuggestionDropdown =
            document.getElementById('branchSuggestion');

        if (
            dropdown &&
            !dropdown.contains(target) &&
            this.isStateDropdownOpen
        ) {
            this.isStateDropdownOpen = false;
        }

        if (
            branchSuggestionDropdown &&
            !branchSuggestionDropdown.contains(target) &&
            this.branchSuggestion.length > 0
        ) {
            this.branchSuggestion = [];
        }
    }

    ngOnInit() {
        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });
        this.getStatesList();
    }

    @ViewChild(MatExpansionPanel) expansionPanel: MatExpansionPanel;

    toggleExpansionPanel() {
        this.isToggleOpen = false;
        this.expansionPanel.toggle();
    }

    onSearchBranch(searchText: string) {
        if (!searchText) {
            this.branches = this.initialBranchesList;
            return;
        }

        //search by city or postcode
        const filteredBranches = this.initialBranchesList.filter(
            (branch) =>
                branch.city.toLowerCase().includes(searchText.toLowerCase()) ||
                branch.ptc.toLowerCase().includes(searchText.toLowerCase())
        );
        this.branches = filteredBranches;
        this.branchSuggestion = filteredBranches;
        this.isStateDropdownOpen = false;
        this.selectedState = null;
    }

    onSubmit() {
        if (this.disableSubmitBtn == true) {
            if (
                this.eligibilityDetails.prodSelectionList.branchActive == 'Y' &&
                this.selectedBranchIndex === null
            ) {
                let lang = localStorage.getItem('language');
                if (lang == 'en') {
                    this.toastr.success(
                        `Please select the branch for ${this.eligibilityDetails.prodSelectionList.prodNameList[0].productName} product to proceed.`
                    );
                } else {
                    this.toastr.success(
                        `Sila pilih cawangan untuk produk ${this.eligibilityDetails.prodSelectionList.prodNameList[0].productName}.`
                    );
                }
            }
        } else {
            this.disableSubmitBtn = true;
            let eligibilityReqObj: EligibilityReqType = {
                caseId: this.caseId,
                selection: [{ prodCode: this.prodCode }],
            };
            if (this.eligibilityDetails.prodSelectionList.branchActive == 'Y') {
                eligibilityReqObj.selection[0].selectedBranch =
                    this.branches[this.selectedBranchIndex].branchName;
            }
            this.router.navigate(['/application-document-upload'], {
                state: {
                    caseId: this.caseId,
                    fromResume: this.fromResume,
                    checkMatchingProduct: true,
                    productName: this.productName,
                    objectRequested: eligibilityReqObj,
                    docsCondition:
                        this.eligibilityDetails.prodSelectionList.uploadDocs,
                },
            });
        }
    }
    onSelectBranch(index: number, branchName: string) {
        if (index > -1 && index < this.branches.length) {
            this.disableSubmitBtn = false;
        }

        this.selectedBranchIndex = index;
        this.selectedBranchName = branchName;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    getStatesList() {
        this.applicationService.getStates().subscribe({
            next: (res) => {
                this.stateOptions = res.states;
            },
            error: (err) => { },
        });
    }

    toggleDropdown(event: MouseEvent) {
        event.stopPropagation();
        this.isStateDropdownOpen = !this.isStateDropdownOpen;
    }

    selectState(state: string): void {
        if (this.selectedState === state) {
            this.resetState();
        } else {
            this.selectedState = state;
            const customEvent = {
                target: {
                    value: state,
                },
            } as unknown as Event;

            this.onStateChange(customEvent);
        }
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    onStateChange(event: Event): void {
        const selectedState = (event.target as HTMLSelectElement).value;
        this.branches = selectedState
            ? this.initialBranchesList.filter(
                  (branch) => branch.state === selectedState
              )
            : this.initialBranchesList;
    }

    resetState(): void {
        this.selectedState = null;
        this.branches = this.initialBranchesList;
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    selectAutoSuggestion(branch: any) {
        this.searchInput = `${branch.ptc}, ${branch.city}`;
        this.branches = this.initialBranchesList.filter(
            (b) =>
                b.city.toLowerCase() === branch.city.toLowerCase() &&
                b.ptc.toLowerCase() === branch.ptc.toLowerCase()
        );
        this.branchSuggestion = [];
    }

    highlightText(text: string, search: string): string {
        if (!search) return text;
        const pattern = search
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
            .split(' ')
            .filter((t) => t.length > 0)
            .join('|');
        const regex = new RegExp(pattern, 'gi');
        return text.replace(
            regex,
            (match) => `<span class="tw-text-[#003A70]">${match}</span>`
        );
    }

    clearSearchInput() {
        this.searchInput = '';
        this.branches = this.initialBranchesList;
    }
}
